import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Elements } from '@stripe/react-stripe-js'
import { StripeContext } from 'contexts'
import { createStripeOptions } from 'utils/stripeOptions'
import StripeAutoRenewalForm from './StripeAutoRenewalForm'

const propTypes = {
  stripeSetupIntentId: PropTypes.string.isRequired,
  customerSessionClientSecret: PropTypes.string,
}

function StripeAutoRenewalElements({
  stripeSetupIntentId,
  customerSessionClientSecret = null,
  ...formProps
}) {
  const stripePromise = useContext(StripeContext)

  return (
    <Elements
      stripe={stripePromise}
      options={createStripeOptions(stripeSetupIntentId, customerSessionClientSecret)}
    >
      <StripeAutoRenewalForm
        stripeSetupIntentId={stripeSetupIntentId}
        {...formProps}
      />
    </Elements>
  )
}

StripeAutoRenewalElements.propTypes = propTypes

export default StripeAutoRenewalElements
